export function getQueryStringMap() {

	let qs_map = {};
	let href =  decodeURIComponent(window.location.href);
	let query = href.split('?')[1];
	if (query !== undefined && query.length > 0) {
		let qs_variables = query.replace(/\?/g, "").split("&");

		for (let i = 0; i < qs_variables.length; i++) {
			let qs_single_variable = qs_variables[i];

			let qs_kv = qs_single_variable.split("=");
			
			let k = qs_kv[0];
			let v = qs_kv[1];

			qs_map[k] = v;
		}

	}
	return qs_map;

}
